import { API_DATA_FORMAT, API_STATUS } from 'core-lib/constants/network';
import ip from 'icepick';
import { BrowsingMode, SEARCH_INITIAL_STATE } from '../constants';
import { AllUsersListing } from '../types/Listing';
import Store, { initHomepageData } from '../types/Store';
import {
  RESET_CLIENT_DATA,
  RESET_DATA,
  UPDATE_ALL_USERS_LISTING,
  UPDATE_BROWSING_MODE,
  UPDATE_CLIENT_CARS_DATA,
  UPDATE_CURRENT_DEALER,
  UPDATE_HOME_PAGE,
  UPDATE_REFERRAL_DATA,
  UPDATE_SEARCH_DATA,
  UPDATE_SOCIETY_DATA,
  UPDATE_USER_CAR_STATUS,
  UPDATE_RESTRICT_DATA,
} from './type';

const initData = {
  ...API_DATA_FORMAT,
  data: initHomepageData,
};

const initAllUsersListingData: AllUsersListing = {
  ...API_DATA_FORMAT,
  data: [],
  nextPage: 1,
  totalCount: 0,
  hasMore: true,
};

const initialState: Store = ip.freeze({
  homepage: { ...initData },
  referralData: {
    list: [],
    apiStatus: API_STATUS.default,
    page: 1,
    limit: 15,
    hasMore: true,
    input: '',
  },
  allUsersListing: {
    all: { ...initAllUsersListingData },
    suv: { ...initAllUsersListingData },
    hatchback: { ...initAllUsersListingData },
    sedan: { ...initAllUsersListingData },
  },
  societyData: {
    data: {
      vehicleList: [],
      title: null,
      subtitle: null,
      totalCount: 0,
    },
    apiStatus: API_STATUS.default,
    page: 1,
    limit: 15,
    hasMore: true,
  },
  hasNoCar: false,
  clientCarsData: {
    carsData: {
      apiStatus: API_STATUS.default,
      list: [],
    },
    modelClients: {},
    clientId: '',
  },
  searchData: SEARCH_INITIAL_STATE,
  browsingMode: BrowsingMode.default,
  restrictData: {
    carAdded: false,
    carReviewAdded: false,
    carSkipSelected: false,
    dealerAdded: false,
    dealerReviewAdded: false,
    dealerSkipSelected: false,
  },
  currentDealer: null,
});

const callDirectoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_HOME_PAGE: {
      state = ip.setIn(state, ['homepage'], action.payload);
      return state;
    }
    case UPDATE_REFERRAL_DATA: {
      state = ip.setIn(state, ['referralData'], action.payload);
      return state;
    }
    case UPDATE_ALL_USERS_LISTING: {
      state = ip.setIn(state, ['allUsersListing'], action.payload);
      return state;
    }
    case UPDATE_SOCIETY_DATA: {
      state = ip.setIn(state, ['societyData'], action.payload);
      return state;
    }
    case UPDATE_USER_CAR_STATUS: {
      state = ip.setIn(state, ['hasNoCar'], action.payload);
      return state;
    }
    case UPDATE_CLIENT_CARS_DATA: {
      state = ip.setIn(state, ['clientCarsData'], action.payload);
      return state;
    }
    case UPDATE_BROWSING_MODE: {
      state = ip.setIn(state, ['browsingMode'], action.payload);
      return state;
    }
    case UPDATE_RESTRICT_DATA: {
      state = ip.setIn(state, ['restrictData'], action.payload);
      return state;
    }
    case UPDATE_SEARCH_DATA: {
      state = ip.setIn(state, ['searchData'], action.payload);
      return state;
    }
    case UPDATE_CURRENT_DEALER: {
      state = ip.setIn(state, ['currentDealer'], action.payload);
      return state;
    }
    case RESET_CLIENT_DATA: {
      state = ip.setIn(state, ['clientCarsData'], initialState.clientCarsData);
      return state;
    }
    case RESET_DATA: {
      state = ip.setIn(state, ['homepage'], initialState.homepage);
      state = ip.setIn(state, ['clientCarsData'], initialState.clientCarsData);
      if (action?.payload?.activeTab) {
        state = ip.setIn(state, ['searchData'], {
          ...initialState.searchData,
          activeTab: action.payload.activeTab,
        });
      } else {
        state = ip.setIn(state, ['searchData'], initialState.searchData);
      }
      return state;
    }
    default:
      return state;
  }
};

export default callDirectoryReducer;
